// extracted by mini-css-extract-plugin
export default {"hero_heading":"styles_hero_heading__k7O8f","small_note":"styles_small_note__pTjCv","nomal_text":"styles_nomal_text__-eeac"};